'use client'
import { createContext, useContext, useEffect, useState } from 'react';
import { useUser } from '@/contexts/UserContext'
import { useRouter } from 'next/navigation'

const ShowContext = createContext();

export function ShowProvider({ children }) {
    const [show, setShow] = useState(null);
    const [shows, setShows] = useState([]);
    const {user} = useUser()
    const router = useRouter()
    const fetchShows = async () => {
        try {
            const response = await fetch('/api/shows')
            if (!response.ok) {
                throw new Error('Failed to fetch shows')
            }

            const data = await response.json()
            
            setShows(data)
            return data;
        } catch (error) {
            console.error(error)
        } 
    }

    const fetchShow = async (showId) => {
        try {
            const response = await fetch(`/api/shows/${showId}`)
            if (!response.ok) {
                throw new Error('Failed to fetch show')
            }
            const data = await response.json()
            return data;
        } catch (error) {
            console.error(error)
        }
    }

    const updateShow = async(showId) => {
        const newShow = await fetchShow(showId)
        document.cookie = `show=${newShow._id}; path=/`;
        setShow(newShow);
    }

    const saveShow = async(data) => {
        if(!show) {
            throw new Error('Show not found')
        }

        try{
            const response = await fetch(`/api/shows/${show._id}`, {
                method: 'PUT',
                body: JSON.stringify({
                    ...show,
                    ...data
                })
            })

            if(!response.ok) {
                throw new Error('Failed to save show')
            }

            const newShow = await response.json()
            setShow(newShow)
            return newShow
        }catch(error){
            console.error(error)
        }
    }

    const createShow = async(data) => {
        try{
            const response = await fetch(`/api/shows`, {
                method: 'POST',
                body: JSON.stringify(data)
            })

            if(!response.ok) {
                throw new Error('Failed to create show')
            }

            const newShow = await response.json()
            setShow(newShow)
            return newShow
        }catch(error){
            console.error(error)
        }
    }

    const switchShow = async(showId) => {
        document.cookie = `show=${showId}; path=/`;
        window.location.reload()
        window.location.href = `/show/episodes`
    }

    const getData = async() => {
        const _shows = await fetchShows()
        if(_shows.length === 0){
            router.push('/')
            return
        }

        const showCookie = document.cookie.split('; ').find(row => row.startsWith('show='))?.split('=')[1]
        if(showCookie && _shows.find(s => s._id === showCookie)) {
            await updateShow(showCookie)
        }else if(_shows.length > 0){
            await updateShow(_shows[0]._id)
        }
    }


    useEffect(() => {
        if(user){
            getData()
        }
    }, [user])

    return (
        <ShowContext.Provider value={{ show, updateShow, fetchShows, shows, switchShow, saveShow, createShow, fetchShow}}>
            {children}
        </ShowContext.Provider>
    );
}

export function useShow() {
    const context = useContext(ShowContext);
    if (!context) {
        throw new Error('useShow must be used within a ShowProvider');
    }
    return context;
}
